import React from 'react';
import ContentBuilder from '../../core/ContentBuilder';
import styles from './DivisionList.module.scss';

interface DivisionItem {
  label?: string;
  text?: string;
  content?: any[];
  note?: string;
}

interface Division {
  title: string;
  items: DivisionItem[];
}

interface DivisionListProps {
  data: Division[];
}

export class DivisionList extends React.Component<DivisionListProps> {
  render() {
    const data = this.props['data'];
    return (
      <dl className={styles['division-list']}>
        {data?.map((division, i) => (
          <div key={i} className={styles['division']}>
            <dt className={styles['division-title']}>{division.title}</dt>
            <dd className={styles['items']}>
              <dl>
                {division.items?.map((item, j) => (
                  <div key={j} className={styles['item']}>
                    {item.label && (
                      <dt className={styles['item-label']}>{item.label}</dt>
                    )}
                    {item.text !== undefined && (
                      <dd className={styles['item-body']}>
                        {ContentBuilder.build(item.text, {}, styles)}
                      </dd>
                    )}
                    {item.content !== undefined && (
                      <dd className={styles['item-content']}>
                        {ContentBuilder.build(item.content, {}, styles)}
                      </dd>
                    )}
                    {item.note && (
                      <dd className={styles['item-note']}>
                        {ContentBuilder.build(item.note, {}, styles)}
                      </dd>
                    )}
                  </div>
                ))}
              </dl>
            </dd>
          </div>
        ))}
      </dl>
    );
  }
}
